import { createSlice } from '@reduxjs/toolkit';

const NAME = 'customer';
const INITIAL_STATE = null;

const customerReducer = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        setActiveCustomer: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        clearActiveCustomer: () => {
            return INITIAL_STATE;
        },
    }
});

export const { setActiveCustomer, clearActiveCustomer } = customerReducer.actions;
export const selectCustomer = (state) => state.customer;
export default customerReducer.reducer;
